import getFunctionData from "../../utils/get-function-data";
import getRandomNumber from "../../utils/get-random-number";
import round from "../../utils/round";

/**
 *
 * @param {String} input
 */
const getNumber = (input) => {
  if (input.startsWith("random(")) {
    const data = getFunctionData(input);
    const parameters = /** @type {String} */ (data.get("parameters"));
    const interval = parameters.split("|");
    const min = +interval[0];
    const max = +interval[1];

    return round(getRandomNumber(min, max), 100);
  } else {
    return Number(input);
  }
}

export default getNumber;